"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var evaluationCell_1 = require("./evaluationCell");
var tripleEstimatesForm_1 = require("./tripleEstimatesForm");
var App_1 = require("../../../App");
var mobx_react_1 = require("mobx-react");
var typestyle_1 = require("typestyle");
var constants_1 = require("../../../constants");
var multiSelect_1 = require("../../lib/multiSelect");
var matrixUtils_1 = require("../../admin/matrixUtils");
var Matrix = (function (_super) {
    __extends(Matrix, _super);
    function Matrix(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickHandler = function (cell_id) {
            App_1.store.risklist.evaluation.current_equals_default().then(function (result) {
                var data = JSON.parse(result);
                if (data.existing_equals_implicit === false) {
                    fancyConfirm(gettext("Are you sure that you want to overwrite the existing evaluation which is based on a manual assessment?"), function () {
                        App_1.store.risklist.evaluation.updateEvaluation(cell_id)
                            .then(function () { return App_1.store.risklist.evaluation.fetchEvaluation(); }).catch(function (error) { return console.log("SERVER ERROR", error); });
                    });
                }
                else {
                    App_1.store.risklist.evaluation.updateEvaluation(cell_id)
                        .then(function () { return App_1.store.risklist.evaluation.fetchEvaluation(); }).catch(function (error) { return console.log("SERVER ERROR", error); });
                }
            }).catch(function (error) { return console.log(error); });
        };
        _this.handleEstimateChange = function (event) {
            var _a = event.currentTarget, name = _a.name, value = _a.value;
            var estimatesCopy = _this.state.estimates.slice();
            var estimateIndex = estimatesCopy.map(function (value) { return value.name; }).indexOf(name);
            var estimateCopy = __assign({}, estimatesCopy[estimateIndex]);
            var is_valid = G$.isNumeric(value);
            estimateCopy.valid = is_valid;
            estimateCopy.value = value;
            estimatesCopy[estimateIndex] = estimateCopy;
            _this.setState({ estimates: estimatesCopy, invalidEstimates: !is_valid });
        };
        _this.handleEvaluateClick = function (event) {
            var estimatesData = {};
            _this.state.estimates.forEach(function (value) {
                estimatesData[value.name] = parseFloat(value.value);
            });
            var frequencies = _this.state.estimates.filter(function (value) { return value.type == 'freq'; });
            var valid_frequencies = _this.validate_estimates(frequencies);
            _this.setState({
                invalidFrequencies: !valid_frequencies
            });
            var consequences = _this.state.estimates.filter(function (value) { return value.type == 'cons'; });
            var valid_consequences = _this.validate_estimates(consequences);
            _this.setState({
                invalidConsequences: !valid_consequences
            });
            if (valid_frequencies && valid_consequences) {
                App_1.store.risklist.evaluation.get_eval_cell(estimatesData).then(function () {
                    App_1.store.risklist.evaluation.updateEstimates(estimatesData).then(function () {
                        App_1.store.risklist.evaluation.fetchEvaluation();
                    });
                });
            }
            else {
                notification(gettext("Error: Triple estimate intervals must be valid") + ".", {
                    type: "error",
                });
            }
        };
        var evaluation = _this.evaluationByEType(_this.props.data.evaluations, constants_1.EvaluationTypeChoices.PRESENT);
        _this.state = {
            evaluation_type: props.evaluation_type,
            estimates: _this.getEstimates(evaluation),
            fmean: evaluation ? evaluation.formatted_fmean : 0,
            cmean: evaluation ? evaluation.formatted_cmean : 0,
            var: evaluation ? evaluation.formatted_explicit_var : 0,
            invalidEstimates: false,
            invalidFrequencies: false,
            invalidConsequences: false
        };
        return _this;
    }
    Matrix.prototype.evaluationByEType = function (evaluations, etype) {
        return evaluations[constants_1.EvaluationTypeChoices.asDict()[etype]];
    };
    Matrix.prototype.getEstimates = function (evaluation) {
        return [{
                name: 'freq_low',
                value: evaluation && (evaluation.freq_low || evaluation.freq_low === 0) ? evaluation.freq_low.toString() : '',
                valid: true,
                type: 'freq'
            }, {
                name: 'freq_mid',
                value: evaluation && (evaluation.freq_mid || evaluation.freq_mid === 0) ? evaluation.freq_mid.toString() : '',
                valid: true,
                type: 'freq'
            }, {
                name: 'freq_high',
                value: evaluation && (evaluation.freq_high || evaluation.freq_high === 0) ? evaluation.freq_high.toString() : '',
                valid: true,
                type: 'freq'
            }, {
                name: 'cons_low',
                value: evaluation && (evaluation.cons_low || evaluation.cons_low === 0) ? evaluation.cons_low.toString() : '',
                valid: true,
                type: 'cons'
            }, {
                name: 'cons_mid',
                value: evaluation && (evaluation.cons_mid || evaluation.cons_mid === 0) ? evaluation.cons_mid.toString() : '',
                valid: true,
                type: 'cons'
            }, {
                name: 'cons_high',
                value: evaluation && (evaluation.cons_high || evaluation.cons_high === 0) ? evaluation.cons_high.toString() : '',
                valid: true,
                type: 'cons'
            }];
    };
    Matrix.prototype.componentDidUpdate = function (prevProps, prevState, prevContext) {
        if (prevProps.data.evaluations != this.props.data.evaluations) {
            var evaluation = this.evaluationByEType(this.props.data.evaluations, this.state.evaluation_type);
            this.setState({
                estimates: this.getEstimates(evaluation),
                fmean: evaluation ? evaluation.formatted_fmean : 0,
                cmean: evaluation ? evaluation.formatted_cmean : 0,
                var: evaluation ? evaluation.formatted_explicit_var : 0,
                invalidEstimates: false,
                invalidFrequencies: false,
                invalidConsequences: false
            });
        }
    };
    Matrix.prototype.validate_estimates = function (estimates) {
        var is_valid = true;
        for (var i = 0; i < estimates.length - 1; i++) {
            if (parseFloat(estimates[i].value) > parseFloat(estimates[i + 1].value)) {
                is_valid = false;
                break;
            }
        }
        return is_valid;
    };
    Matrix.prototype.onEvalTypeChange = function (eval_type) {
        var etype = Number(eval_type);
        if (etype) {
            var evaluation = this.evaluationByEType(this.props.data.evaluations, etype);
            this.setState({
                evaluation_type: etype,
                estimates: this.getEstimates(evaluation),
                fmean: evaluation ? evaluation.formatted_fmean : 0,
                cmean: evaluation ? evaluation.formatted_cmean : 0,
                var: evaluation ? evaluation.formatted_explicit_var : 0,
                invalidEstimates: false,
                invalidFrequencies: false,
                invalidConsequences: false
            });
            App_1.store.risklist.evaluation.setEtype(etype);
        }
    };
    Matrix.prototype.render = function () {
        var _this = this;
        var base = "Matrix";
        var isOppClass = this.props.data.matrix.is_opportunity ? 'Matrix__Opportunity' : 'Matrix__Risk';
        var tableClassName = (0, typestyle_1.classes)(base, isOppClass);
        return (React.createElement(React.Fragment, null,
            this.props.data.matrix.explicit_evaluation && (React.createElement(tripleEstimatesForm_1.default, { estimates: this.state.estimates, fmean: this.state.fmean, cmean: this.state.cmean, var: this.state.var, unit: this.props.data.matrix.risk_target_unit, invalid: this.state.invalidEstimates, invalidFrequencies: this.state.invalidFrequencies, invalidConsequences: this.state.invalidConsequences, change: this.handleEstimateChange, click: this.handleEvaluateClick })),
            React.createElement("label", null,
                gettext("Evaluation type"),
                ": "),
            " ",
            React.createElement(multiSelect_1.Multiselect, { choices: constants_1.EvaluationTypeChoices.asChoicesWithIcons(), value: [this.state.evaluation_type.toString()], name: "evaluation_type", single_mode: true, onSingleChange: this.onEvalTypeChange.bind(this), enableHTML: true, buttonContainerClass: "Multiselect--custom" }),
            React.createElement("table", { className: tableClassName },
                React.createElement("tr", null,
                    React.createElement("th", null, this.props.data.matrix.risk_target_name),
                    this.props.data.matrix.consequences.map(function (consequence) { return (React.createElement("th", { key: consequence.id, className: "Consequence__Column" },
                        React.createElement("span", { className: "Consequence__Name" }, consequence.name),
                        React.createElement("br", null),
                        React.createElement("span", { className: "Consequence__Desc" }, (0, matrixUtils_1.displayConsequence)(consequence, _this.props.data.matrix.consequence_display)))); })),
                this.props.data.matrix.frequencies.map(function (frequency) { return (React.createElement("tr", { key: frequency.id },
                    React.createElement("td", { className: "Frequency__Column" },
                        React.createElement("span", { className: "Frequency__Name" }, frequency.name),
                        React.createElement("br", null),
                        React.createElement("span", { className: "Frequency__Desc" }, (0, matrixUtils_1.displayFrequency)(frequency, _this.props.data.matrix.frequency_display))),
                    _this.props.data.matrix.cells
                        .filter(function (cell) { return cell.row == frequency.row; })
                        .map(function (cell) {
                        var consequence = _this.props.data.matrix.consequences[cell.column - 1];
                        var estimates = {
                            freq_low: frequency.low,
                            freq_mid: frequency.mid,
                            freq_high: frequency.high,
                            cons_low: consequence.low,
                            cons_mid: consequence.mid,
                            cons_high: consequence.high
                        };
                        return (React.createElement(evaluationCell_1.default, { key: cell.id, clickHandler: _this.onClickHandler.bind(_this, cell.id), cell: cell, evaluations: _this.props.data.evaluations, evaluationByEType: _this.evaluationByEType, explicit_evaluation: _this.props.data.matrix.explicit_evaluation, estimates: estimates }));
                    }))); }))));
    };
    Matrix = __decorate([
        mobx_react_1.observer
    ], Matrix);
    return Matrix;
}(React.Component));
exports.default = Matrix;
